<button [style.opacity]="open ? 1 : 0.8" class="btn btn-theme btn btn-icon rounded-0 w-100 no-outline" (click)="toggle()">
  <i *ngIf="false" class="mdi {{icon}} primary-icon"></i>
  <span class="w-100 text-left">
    {{label}}
  </span>
  <i class="mdi mdi-chevron-down" [ngClass]="{'mdi-rotate-180': open}"></i>

</button>
<div [style.max-height.px]="size" class="menu-body d-block bg-theme-dark">

    <ng-container *ngFor="let item of itens">
        <app-side-nav-item [route]="item.route" [icon]="item.icon" [label]="item.label"></app-side-nav-item>
    </ng-container>

</div>